export default {
	props: {
		trPrefix: {type: String, default: 'restrictionsReasons',},
		reasons: [Object, Array],
	},
	computed:{
		trReasons(){
			const r = [];
			for(const i in this.reasons){
				let msg = this.$t(this.trPrefix+'.'+this.reasons[i].type, {val:this.reasons[i].value});
				if(!msg) continue;
				r.push(msg);
			}
			return r;
		},
		hasRestrictions(){
			return this.trReasons.length>0;
		},
	},
	template: `
<div v-if="hasRestrictions" class="restrictions-reasons-view">
	<div v-for="(msg,i) in trReasons" :key="i" class="reason">{{msg}}</div>
</div>
`,
}
